import React, {Component} from 'react';

export default class RadioButton extends Component {

	state = {
		elementName: 'radio',
		elementId: '',
		label: '',
		itemvalue: '',
		checked : '',
		stateName : ''
	}

	handleClick = (e) => {
		this.setState({
			checked : e.target.value
		});

		this.props.onchange(e, this.state.stateName);
	}

	componentDidMount() {
		let nextProps = this.props;
			
		this.setState({
			elementName: nextProps.name,
			elementId: nextProps.id + nextProps.index,
			label: nextProps.label,
			itemValue: nextProps.value,
			stateName: nextProps.selectedState
		});

	}

	componentWillReceiveProps(nextProps) {
		// console.log(nextProps)
		this.setState({checked : nextProps.checkedItem});

	}

	render() {

		let selectedOption = this.state.checked === this.state.itemValue;
		
		return (
			<div className="md-radio">
                <input type="radio" name={this.state.elementName} id={this.state.elementId} className="md-radiobtn" value={this.state.itemValue} checked={selectedOption} onChange={this.handleClick} />
                <label htmlFor={this.state.elementId}>
                    <span></span>
                    <span className="check"></span>
                    <span className="box"></span> {this.state.label} </label>
            </div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/RadioButton.js
 **/